<div class="row">
  <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
       [labelInput]="'Processo telematico'"
       [valueInput]="ctxBodyFascicolo.fascicolo.flagProcessoTelematico ? 'Si' : 'No'"></div>
</div>
<ng-template [ngIf]="ctxBodyFascicolo.fascicolo.capofila || ctxBodyFascicolo.fascicolo.riunito">
  <div class="row container_fieldset">
    <fieldset class="form-group">
      <legend>Riunione dei giudizi</legend>
      <ng-template [ngIf]="ctxBodyFascicolo.fascicolo.capofila">
        <div labelTextInput class="col-sm-4 bloccodati"
             [typeLabel]="'text'" [labelInput]="'Capofila'"
             [valueInput]="ctxBodyFascicolo.fascicolo.capofila ? 'Si' : 'No'"></div>
      </ng-template>
      <ng-template [ngIf]="ctxBodyFascicolo.fascicolo.riunito">
        <div labelTextInput class="col-sm-4 bloccodati"
             [typeLabel]="'text'" [labelInput]="'Riunito'"
             [valueInput]="ctxBodyFascicolo.fascicolo.riunito ? 'Si' : 'No'"></div>
      </ng-template>
      <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'"
           [labelInput]="'Data riunione'"
           [valueInput]="ctxBodyFascicolo.fascicolo.dataRiunioneGiudizio"></div>
      <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
           [labelInput]="'Motivo riunione'"
           [valueInput]="ctxBodyFascicolo.fascicolo.motivoRiunioneGiudizio"></div>
    </fieldset>
  </div>
</ng-template>

<div class="row">
  <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
       [labelInput]="'Tipo rito'"
       [valueInput]="ctxBodyFascicolo.fascicolo.tipoRitoAlternativo && ctxBodyFascicolo.fascicolo.tipoRitoAlternativo.label ? ctxBodyFascicolo.fascicolo.tipoRitoAlternativo.label : ''"></div>
  <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
       [labelInput]="'N&deg; c/o il Registro Generale Affari Penali'"
       [valueInput]="ctxBodyFascicolo.fascicolo.numeroRegistroGeneraleAffariPenali"></div>
  <div labelTextInput class="col-sm-4 bloccodati"
       [typeLabel]="'text'" [labelInput]="'Oblazione'"
       [valueInput]="ctxBodyFascicolo.fascicolo.richiestaOblazione ? 'Si' : 'No'"></div>
</div>
<div class="row container_fieldset">
  <fieldset class="form-group">
    <legend>Giudici</legend>
    <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
         [labelInput]="'Giudice indagini preliminari (G.I.P.)'"
         [valueInput]="ctxBodyFascicolo.fascicolo.giudiceIndaginiPreliminari"></div>
    <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
         [labelInput]="'Giudice udienza preliminare (G.U.P.)'"
         [valueInput]="ctxBodyFascicolo.fascicolo.giudiceUdienzaPreliminare"></div>
    <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
         [labelInput]="'Pubblico Ministero (P.M.)'"
         [valueInput]="ctxBodyFascicolo.fascicolo.pubblicoMinistero"></div>
  </fieldset>
</div>
<!-- <div class="row container_fieldset">
  <fieldset class="form-group">
    <legend>Prove</legend>
    <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
         [labelInput]="'Sufficienza prove'"
         [valueInput]="ctxBodyFascicolo.fascicolo.sufficienzaProve ? 'Si' : 'No'"></div>
    <div class="col-sm-8 bloccodati">
      <p>
        <label for="prove" class="col-sm-8">Prove</label>
        <span class="longtext">{{ ctxBodyFascicolo.fascicolo.prove }}</span>
      </p>
    </div>
  </fieldset>
</div> -->
<div class="row container_fieldset">
  <div class="col-sm-12">
    <fieldset class="form-group">
      <legend>Misure cautelari</legend>
      <div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'text'"
          [labelInput]="'Misure cautelari'"
          [valueInput]="ctxBodyFascicolo.fascicolo.misureCautelari ? 'Si' : 'No'"></div>
      <div class="col-sm-10 bloccodati">
        <p>
          <label for="misura_adottata" class="col-sm-12" style="padding-left: 0px !important;">Misura adottata</label>
          <span class="longtext">{{ ctxBodyFascicolo.fascicolo.misuraAdottata }}</span>
        </p>
      </div>
    </fieldset>
  </div>
</div>
<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
</div>
